import { customBaseQuery } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";

export interface AccountTypeSearch {
  startAt: number;
  pageSize: number;
  sortDesc: boolean;
}

export interface AccountTypeSearchResult {
  items: AccountType[];
  pageSize: number;
  startAt: number;
  sortDesc: boolean;
  total: number;
}

interface AccountType {
  id: number;
  name: string;
  type: string;
  code: string;
}

export const accountTypeApi = createApi({
  reducerPath: "accountTypeApi",
  baseQuery: customBaseQuery,
  tagTypes: ["accountType"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getAccountTypeById: builder.query<any, number>({
      query: (id) => `/account-type/${id}`,
      providesTags: ["accountType"],
    }),

    getAllAccountType: builder.query({
      query: () => `/account-type`,
      providesTags: ["accountType"],
    }),

    searchAccountType: builder.query<
      AccountTypeSearchResult,
      AccountTypeSearch
    >({
      query: (input) => ({
        url: `/account-type/search`,
        method: "POST",
        body: input,
      }),
      providesTags: ["accountType"],
    }),

    createAccountType: builder.mutation<void, any>({
      query: (input) => ({
        url: `/account-type`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["accountType"],
    }),

    updateAccountType: builder.mutation<void, { id: number; data: any }>({
      query: ({ id, data }) => ({
        url: `/account-type/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["accountType"],
    }),

    deleteAccountType: builder.mutation<void, number>({
      query: (id) => ({
        url: `/account-type/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["accountType"],
    }),
  }),
});

export const {
  useGetAccountTypeByIdQuery,
  useSearchAccountTypeQuery,
  useCreateAccountTypeMutation,
  useUpdateAccountTypeMutation,
  useDeleteAccountTypeMutation,
  useGetAllAccountTypeQuery,
} = accountTypeApi;
